import Hero from '../components/sections/Hero.tsx';
import HowItWorks from '../components/sections/HowItWorks.tsx';
import Process from '../components/sections/Process.tsx';
import QuoteRequest from '../components/sections/QuoteRequest.tsx';

export default function Home() {
  return (
    <div>
      <Hero />
      <HowItWorks />
      <Process />
      <QuoteRequest />
    </div>
  );
}